<template>
  <f7-page
    name="argollas"
    :infinite-distance="50"
    :infinite-preloader="false"
    infinite
    :hide-bars-on-scroll="false"
  >
    <f7-navbar
      :sliding="false"
      innerClass="navbar-separator"
    >
      <!-- <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link> -->
      <f7-nav-title class="text-madai">Argollas</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-md="material:search" href="/buscar/" @click="activarBusqueda = false"></f7-link>
      </f7-nav-right>

      <busqueda
        :activarBusqueda="activarBusqueda"
        :id="'busqueda'"
        :catalogo="catalogo"
        :filtros="filtros"
        @searchbar:disable="activarBusqueda = false"
        @search:load-complete="resp => catalogoPaginador = resp"
        @search:data="resp => catalogoFiltrado = resp"
      ></busqueda>
    </f7-navbar>

    <f7-toolbar tabbar scrollable position="top" class="h-60">
      <f7-link class="text-filter-blue bold">
        Filtros
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'precio' }"
        @click="filtro = 'precio'"
        :tab-link-active="filtro === 'precio'"
      >
        <img src="assets/img/filtros/precio-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[3].minValue === Math.trunc(priceMin) && filtros[3].maxValue === Math.trunc(priceMax) ? 'precio' : 'filtrado' }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'material' }"
        @click="filtro = 'material'"
        :tab-link-active="filtro === 'material'"
      >
        <img src="assets/img/filtros/material-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[1].value === '*' ? 'Material' : filtros[1].value }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'color' }"
        @click="filtro = 'color'"
        :tab-link-active="filtro === 'color'"
      >
        <img src="assets/img/filtros/color-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[2].value === '*' ? 'Color' : filtros[2].value }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'gema' }"
        @click="filtro = 'gema'"
        :tab-link-active="filtro === 'gema'"
      >
        <img src="assets/img/filtros/gema.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[0].value === '*' ? 'Gema' : filtros[0].value }}
        </div>
      </f7-link>
      <f7-link
        class="text-filter-blue bold"
        @click="limpiarFiltros()"
      >
        Reiniciar
      </f7-link>
    </f7-toolbar>

    <f7-list v-if="catalogoPaginador.length === 0">
      <f7-list-item>No se encontraron resultados</f7-list-item>
    </f7-list>

    <template v-else>
      <f7-list class="f7-list-item-no-border m-t-10 m-b-0">
        <f7-list-item
          v-for="(itm, idx) in catalogoPaginador"
          :key="idx"
          :link="`/argolla/${itm.ida_articles}/`"
        >
          <list-argolla :itm="itm"></list-argolla>
        </f7-list-item>
      </f7-list>

      <template v-if="catalogo.length > catalogoPaginador.length && catalogoPaginador.length < catalogoFiltrado.length">
        <div class="text-center m-t-20 p-l-15 p-r-15">
          <f7-button @click="$evento.emit('search:load')" large raised fill>Cargar más</f7-button>
        </div>
      </template>

      <!-- Banner envío -->
      <f7-block class="text-center">
        <img class="wd-100" src="assets/img/banners/msi.jpg" alt="">
        <img class="wd-100" src="assets/img/banners/envio_asegurado.jpg" alt="">
        <img class="m-t-40 m-b-20" src="assets/img/otros/ssl-secure.jpg" alt="" style="border-radius: 10px;" height="50">
      </f7-block>
    </template>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'precio'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Precio</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-list simple-list class="m-0 m-t-20 f7-list-item-no-border p-l-25 p-r-25">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3">
              <f7-range
                ref="precio"
                :min="priceMin"
                :max="priceMax"
                :step="1"
                :value="[filtros[3].minValue, filtros[3].maxValue]"
                :label="true"
                :dual="true"
                @range:change="onChange"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
        <f7-row>
          <f7-col></f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                class="text-center"
                label="Mínimo"
                type="number"
                placeholder="Mínimo"
                :value="filtros[3].minValue"
                @input="filtros[3].minValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                class="text-center"
                label="Máximo"
                type="number"
                placeholder="Máximo"
                :value="filtros[3].maxValue"
                @input="filtros[3].maxValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'gema'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Gema</span>
        </div>
      </f7-toolbar>
      <f7-page-content class="p-10 p-t-20">
        <f7-row>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[0].value === 'diamante' }"
            @click="filtros[0].value === 'diamante' ? filtros[0].value = '*' : filtros[0].value = 'diamante'"
          >
            <img src="assets/img/gema/diamante.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Diamante</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[0].value === 'zirconia' }"
            @click="filtros[0].value === 'zirconia' ? filtros[0].value = '*' : filtros[0].value = 'zirconia'"
          >
            <img src="assets/img/gema/zirconia.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Zircona</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'material'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Material</span>
        </div>
      </f7-toolbar>
      <f7-page-content class="p-10 p-t-20">
        <f7-row class="m-b-20">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === '10K' }"
            @click="filtros[1].value === '10K' ? filtros[1].value = '*' : filtros[1].value = '10K'"
          >
            <img src="assets/img/material/kilates_10.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">10 kilates</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === '14K' }"
            @click="filtros[1].value === '14K' ? filtros[1].value = '*' : filtros[1].value = '14K'"
          >
            <img src="assets/img/material/kilates_14.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">14 kilates</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-310 sheet-border-radius-15" :opened="filtro === 'color'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Color</span>
        </div>
      </f7-toolbar>
      <f7-page-content class="p-10 p-t-20">
        <f7-row class="m-b-20">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'amarillo' }"
            @click="filtros[2].value === 'amarillo' ? filtros[2].value = '*' : filtros[2].value = 'amarillo'"
          >
            <img src="assets/img/color/oro_amarillo.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Amarillo</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'blanco' }"
            @click="filtros[2].value === 'blanco' ? filtros[2].value = '*' : filtros[2].value = 'blanco'"
          >
            <img src="assets/img/color/oro_blanco.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Blanco</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'rosa' }"
            @click="filtros[2].value === 'rosa' ? filtros[2].value = '*' : filtros[2].value = 'rosa'"
          >
            <img src="assets/img/color/oro_rosa.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Rosa</span>
          </f7-col>
        </f7-row>
        <f7-row>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'combinado' }"
            @click="filtros[2].value === 'combinado' ? filtros[2].value = '*' : filtros[2].value = 'combinado'"
          >
            <img src="assets/img/color/oro_amarillo_blanco.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Amarillo y Blanco</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].value === 'florentino' }"
            @click="filtros[2].value === 'florentino' ? filtros[2].value = '*' : filtros[2].value = 'florentino'"
          >
            <img src="assets/img/color/florentino.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Florentino</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <!-- <f7-toolbar class="bg-madai" bottom>
      <f7-link class="text-white" icon-md="material:refresh" @click="limpiarFiltros()"><span class="fs-11" style="position: relative;">Resetear</span></f7-link>
      <p class="fs-11 text-white margin-auto">Mostrando {{ catalogoPaginador.length }} de {{ catalogoFiltrado.length }} resultados de {{ catalogo.length }} registros.</p>
    </f7-toolbar> -->
  </f7-page>
</template>

<script>
import busqueda from '@/components/busqueda'
import listArgolla from '@/components/list-argolla.vue'

export default {
  components: {
    busqueda,
    listArgolla
  },
  data () {
    return {
      cargando: true,
      activarBusqueda: false,
      delay: null,
      catalogo: [],
      catalogoFiltrado: [],
      catalogoPaginador: [],
      filtros: [
        {
          prop: 'gem',
          value: '*'
        },
        {
          prop: 'specification',
          value: '*'
        },
        {
          prop: 'color',
          value: '*'
        },
        {
          prop: 'price',
          minValue: 0,
          maxValue: 0
        }
      ],
      filtro: '',
      priceMin: 0,
      priceMax: 0
    }
  },
  methods: {
    async init () {
      try {
        this.cargando = true
        this.$f7.dialog.preloader('Descargando catálogo...')
        this.catalogo = await this.$api.catalogo.argollas()
        // Buscar precios mínimos y máximos
        this.catalogo.forEach((item, idx) => {
          if (idx === 0) {
            this.priceMin = item.price
            this.priceMax = item.price
          }
          this.priceMin = item.price < this.priceMin ? item.price : this.priceMin
          this.priceMax = item.price > this.priceMax ? item.price : this.priceMax
        })
        // Asignar precios mínimos y máximos a filtros y range
        this.filtros[3].minValue = this.$refs.precio.f7Range.min = Math.floor(this.priceMin)
        this.filtros[3].maxValue = this.$refs.precio.f7Range.max = Math.ceil(this.priceMax)
        this.cargando = false
        this.$f7.dialog.close()
      } catch (err) {
        this.catalogo = []
        this.cargando = false
        this.$f7.dialog.close()
      }
    },
    limpiarFiltros () {
      this.filtros.forEach((itm, idx) => {
        if (this.filtros[idx].value) { this.filtros[idx].value = '*' }
      })
      this.$refs.precio.setValue([this.priceMin, this.priceMax])
    },
    actualizarElemento (item) {
      this.$set(this.catalogo, this.catalogo.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoFiltrado, this.catalogoFiltrado.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoPaginador, this.catalogoPaginador.findIndex(itm => itm.cve === item.cve), item)
    },
    onChange (values) {
      clearTimeout(this.delayBusqueda)

      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 3, { minValue: values[0], maxValue: values[1], prop: 'price' })
      }, 250)
    },
    onPageClose () {
      this.$evento.off('update-content')
    }
  },
  created () {
    this.init()
    this.$evento.on('update-content', this.actualizarElemento)
  }
}
</script>

<style scoped>
.b-r-4 {
  border-radius: 4px;
}

.thumb {
  height: 150px;
}

.input-with-value {
  text-align: center;
}
</style>
